import { List } from 'immutable'

export default List([
  'amount',
  'qty',
  'amount_per_qty',
  'qty_pi',
  'amount_pi',
  'receipt_count',
  'sku_count',
  'store_count',
  'avg_ymd',
  'last_sale_ymd',
  'discount_amount',
  'dispose_amount',
  'loss_amount',
  'stock_qty',
  'stock_turn_over_rate',
  'stock_turn_over_ymd',
])
